//#region components/codeblock/codeblock_constants.js
var e = [
	"100",
	"200",
	"300",
	"400",
	"xs",
	"sm",
	"md",
	"lg"
], t = 200, n = {
	100: "xs",
	200: "sm",
	300: "md",
	400: "lg"
};
//#endregion
export { e as CODEBLOCK_SIZES, t as CODEBLOCK_SIZE_DEFAULT, n as CODEBLOCK_SIZE_MAP };

//# sourceMappingURL=codeblock-constants.js.map